'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("routeUtils", function ($route) {
  var routeUtils = {
    /**
     * Interpolate section string ( with param ) with given url to get actual section url.
     *
     * I.E : '/fiche/:id' + '/fiche/my-id/subsection' -> '/fiche/my-id'
     *
     * @param section The section url to interpolate.
     * @param url The url to interpolate from.
     */
    interpolateSection: function interpolateSection(section, url) {
      var replaced = routeUtils.getRouteRegexp(section, false).exec(url);
      return replaced && replaced[0] || null;
    },
    /**
     * Parse given route and convert it to regexp.
     *
     * @param route the route url to convert
     * @param exact if true, will surround route regexp with "^route$"
     */
    getRouteRegexp: function getRouteRegexp(route, exact) {
      var parsed = route.replace(/([().])/g, '\\$1').replace(/(\/)?:(\w+)([\?\*])?/g, function (_, slash, key, option) {
        var optional = option === '?' ? option : null;
        var star = option === '*' ? option : null;
        slash = slash || '';
        return '' + (optional ? '' : slash) + '(?:' + (optional ? slash : '') + (star && '(.+?)' || '([^/]+)') + (optional || '') + ')' + (optional || '');
      }).replace(/([\/$\*])/g, '\\$1');
      if (exact) {
        parsed = "^" + parsed + "$";
      }
      return new RegExp(parsed);
    },
    /**
     * Replace parameter names by parameters value for given route.
     * Parameters not contained in param map will not be replaced.
     *
     * i.e : http://myapp/:param { param : "hello" } -> http://myapp/hello
     */
    replaceParams: function replaceParams(route, params) {
      return route.replace(/(\/)?:(\w+)([\?|\*])?/g, function (capture, slash, key, option, startIdx) {
        return _.has(params, key) ? slash + params[key] : capture;
      });
    },
    /**
     * Force reloading of the current route.
     */
    reloadRoute: function reloadRoute() {
      $route.reload();
    },
    /**
     * Force reloading of the app to the current page.
     */
    reloadApp: function reloadApp() {
      window.location.reload();
    }
  };
  return routeUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/routeUtils.js
// module id = 2762
// module chunks = 13